// src/app/state/models/user.model.ts
import { ApiDefUserData } from '@api/models/api-def-user-data';

export type UserData = Omit<ApiDefUserData, 'createdAt' | 'updatedAt'> & {
  readonly createdAt?: Date;
  readonly updatedAt?: Date;
};

export class UserWrapper {
  data: UserData;
  loadedAt: Date;

  constructor(data: unknown) {
    this.data = data as UserData;
    this.loadedAt = new Date();
  }
}

export interface UserState {
  users: { [userId: string]: UserWrapper };
  userList: readonly UserData[];
  total: number;
}

export const initialUserState: UserState = {
  users: {},
  userList: [],
  total: 0,
};
